import { StandardEvents } from '@shopify/events';

const desktopDrawerQuery = window.matchMedia('(min-width: 990px)');
const pendingProductForms = new WeakMap();

function productFormFor(event) {
  return event.target instanceof Element ? event.target.closest('product-form-component') : null;
}

function productFeedback(form, message) {
  let feedback = form.querySelector('[ref="addToCartTextError"]');
  if (!feedback) {
    feedback = document.createElement('div');
    feedback.className = 'product-form-text__error smi-cart-feedback hidden';
    feedback.setAttribute('ref', 'addToCartTextError');
    form.appendChild(feedback);
  }
  feedback.classList.add('smi-cart-feedback');
  feedback.setAttribute('role', 'status');
  feedback.setAttribute('aria-live', 'polite');
  feedback.textContent = message;
  feedback.classList.toggle('hidden', !message);

  const drawer = cartDrawer();
  drawer?.querySelector('[data-smi-cart-operation-feedback]')?.remove();
  if (!message || !drawer?.hasAttribute('open') || drawer.contains(form)) return;
  const items = drawer.querySelector('.cart-drawer__items');
  if (!items) return;
  const notice = document.createElement('div');
  notice.className = 'smi-cart-feedback';
  notice.setAttribute('data-smi-cart-operation-feedback', '');
  notice.setAttribute('role', 'status');
  notice.textContent = message;
  items.prepend(notice);
}

function preventDuplicateSubmit(event) {
  const form = productFormFor(event);
  if (!form || !pendingProductForms.has(form)) return;
  event.preventDefault();
  event.stopImmediatePropagation();
}

function trackProductRequest(event) {
  const form = productFormFor(event);
  if (event.action !== 'add' || !event.promise || !form || pendingProductForms.has(form)) return;

  const state = {
    variantId: form.querySelector('input[name="id"]')?.value,
    buttons: [...form.querySelectorAll('[ref="addToCartButton"]')].map((button) => ({
      button,
      disabled: button.disabled,
    })),
    message: '',
  };
  pendingProductForms.set(form, state);
  productFeedback(form, '');
  form.setAttribute('aria-busy', 'true');
  state.buttons.forEach(({ button }) => { button.disabled = true; });

  event.promise.then(({ detail } = {}) => {
    if (detail?.didError) {
      state.message ||= 'Cet article n’a pas pu être ajouté. Vérifiez la disponibilité et la quantité.';
      requestAnimationFrame(() => productFeedback(form, state.message));
    } else {
      productFeedback(form, '');
    }
  }).catch(() => {
    state.message ||= 'La confirmation de l’ajout a échoué. Vérifiez votre panier avant de réessayer.';
    productFeedback(form, state.message);
  }).finally(() => {
    pendingProductForms.delete(form);
    form.removeAttribute('aria-busy');
    if (form.querySelector('input[name="id"]')?.value === state.variantId) {
      state.buttons.forEach(({ button, disabled }) => {
        if (form.contains(button)) button.disabled = disabled;
      });
    }
  });
}

function showProductError(event) {
  const form = productFormFor(event);
  if (!form) return;
  const description = event.detail?.description;
  const message = event.code === 'SERVICE_UNAVAILABLE'
    ? 'La confirmation de l’ajout a échoué. Vérifiez votre panier avant de réessayer.'
    : typeof description === 'string' && description.trim()
      ? description
      : event.error || 'Cet article n’a pas pu être ajouté. Vérifiez la disponibilité et la quantité.';
  const state = pendingProductForms.get(form);
  if (state) state.message = message;
  queueMicrotask(() => productFeedback(form, message));
}

function showCartError(event) {
  if (event.code !== 'SERVICE_UNAVAILABLE' || !(event.target instanceof Element)) return;
  const component = event.target.closest('cart-items-component');
  if (!component) return;
  const container = component.querySelector('.cart-drawer__items') || component;
  container.querySelector('[data-smi-cart-operation-feedback]')?.remove();
  const notice = document.createElement('div');
  notice.className = 'smi-cart-feedback';
  notice.setAttribute('data-smi-cart-operation-feedback', '');
  notice.setAttribute('role', 'status');
  notice.textContent = 'La mise à jour du panier n’a pas pu être confirmée. Vérifiez les quantités avant de payer. ';
  const link = document.createElement('a');
  link.href = `${window.Shopify?.routes?.root || '/'}cart`;
  link.textContent = 'Actualiser le panier';
  notice.appendChild(link);
  container.prepend(notice);
}

function cartDrawer() {
  return document.getElementById('cart-drawer');
}

function labelCheckout() {
  document.querySelectorAll('#cart-drawer .cart__checkout-button .button-text, .content-for-layout[data-template^="cart"] .cart__checkout-button .button-text').forEach((label) => {
    label.textContent = 'Finaliser la commande';
  });
}

function solfixStudioImage(variantId) {
  if (!variantId) return null;
  for (const id of ['solmire-solfix-studio-images', 'solmire-mppt-studio-images', 'solmire-panel-studio-images']) {
    const registry = document.getElementById(id);
    if (!registry) continue;
    try {
      const image = JSON.parse(registry.textContent)[String(variantId)];
      if (image?.src) return image;
    } catch (_) {}
  }
  return null;
}

function applySolfixStudioImage(img, studio) {
  if (!studio?.src) return;
  img.removeAttribute('srcset');
  img.removeAttribute('sizes');
  img.src = studio.src;
  img.alt = studio.alt || '';
  if (studio.width && studio.height) {
    img.width = studio.width;
    img.height = studio.height;
  }
  img.style.objectFit = 'contain';
}

function hydrateCartImages() {
  const images = [...document.querySelectorAll('#cart-drawer img.cart-items__media-image, .content-for-layout[data-template^="cart"] img.cart-items__media-image')];
  images.forEach((img, index) => {
    const row = img.closest('.cart-items__table-row');
    const studio = solfixStudioImage(row?.dataset.solfixVariantId || row?.dataset.key?.split(':')[0]);
    if (studio) applySolfixStudioImage(img, studio);
    img.loading = index === 0 ? 'eager' : 'lazy';
    img.decoding = 'async';
    try { img.fetchPriority = index === 0 ? 'high' : 'auto'; } catch (_) {}
    img.style.opacity = '1';
    img.style.visibility = 'visible';

    if (!img.complete) {
      const src = img.getAttribute('src');
      const srcset = img.getAttribute('srcset');
      if (srcset) img.setAttribute('srcset', srcset);
      if (src) img.setAttribute('src', src);
    }
  });
}

function cartRows() {
  return document.querySelectorAll('#cart-drawer .cart-items__table-row[data-key], .content-for-layout[data-template^="cart"] .cart-items__table-row[data-key]');
}

async function hydrateMissingCartImages() {
  const rows = [...cartRows()].filter((row) => !row.querySelector('img.cart-items__media-image'));
  if (!rows.length) return;

  try {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    if (!response.ok) return;
    const cart = await response.json();
    const byKey = new Map((cart.items || []).map((item) => [item.key, item]));

    rows.forEach((row) => {
      const item = byKey.get(row.dataset.key);
      const studio = solfixStudioImage(item?.variant_id || row.dataset.solfixVariantId);
      const src = studio?.src || item?.featured_image?.url || item?.image;
      const cell = row.querySelector('.cart-items__media');
      if (!src || !cell || cell.querySelector('img')) return;

      const link = document.createElement('a');
      link.href = item.url || '#';
      link.className = 'cart-items__media-container';
      link.style.setProperty('--ratio', '1');

      const img = document.createElement('img');
      img.className = 'cart-items__media-image border-style';
      img.src = src;
      img.alt = item.featured_image?.alt || item.product_title || item.title || '';
      if (studio) applySolfixStudioImage(img, studio);
      img.loading = 'lazy';
      img.decoding = 'async';
      try { img.fetchPriority = 'auto'; } catch (_) {}

      link.appendChild(img);
      cell.appendChild(link);
    });
    hydrateCartImages();
  } catch (error) {
    if (error?.name !== 'AbortError') console.warn('[SOLMIRE] Cart image fallback skipped:', error);
  }
}

function resetDrawerScroll() {
  const items = document.querySelector('#cart-drawer .cart-drawer__items');
  if (items) items.scrollTop = 0;
}

function removeCartFromPersistedState() {
  try {
    const ids = (sessionStorage.getItem('theme-drawer-open') || '')
      .split(',')
      .filter(Boolean)
      .filter((id) => id !== 'cart-drawer');

    if (ids.length) sessionStorage.setItem('theme-drawer-open', ids.join(','));
    else sessionStorage.removeItem('theme-drawer-open');
  } catch (_) {}
}

function ensureDesktopBackdrop() {
  let backdrop = document.querySelector('.smi-cart-backdrop');
  if (backdrop) return backdrop;

  backdrop = document.createElement('div');
  backdrop.className = 'smi-cart-backdrop';
  backdrop.setAttribute('aria-hidden', 'true');
  backdrop.addEventListener('click', () => {
    const drawer = cartDrawer();
    if (drawer && typeof drawer.close === 'function') drawer.close();
  });
  document.body.appendChild(backdrop);
  return backdrop;
}

function clearDesktopOverlay() {
  document.documentElement.classList.remove('smi-cart-open');
  document.querySelector('.smi-cart-backdrop')?.remove();
}

function neutralizePageSqueeze() {
  document.querySelector('.page-wrapper')?.classList.remove('page-wrapper--drawer-open');
}

function syncDesktopOverlay() {
  const drawer = cartDrawer();
  const isOpen = Boolean(drawer?.hasAttribute('open'));

  if (isOpen && desktopDrawerQuery.matches) {
    neutralizePageSqueeze();
    document.documentElement.classList.add('smi-cart-open');
    ensureDesktopBackdrop();
    requestAnimationFrame(neutralizePageSqueeze);
  } else {
    clearDesktopOverlay();
  }
}

function hydrateCartUI() {
  const drawer = cartDrawer();
  if (drawer) drawer.setAttribute('no-persist', '');
  removeCartFromPersistedState();
  labelCheckout();
  hydrateCartImages();
  hydrateMissingCartImages();
  syncDesktopOverlay();
}

async function syncCartUI(event) {
  document.querySelectorAll('[data-smi-cart-operation-feedback]').forEach((notice) => notice.remove());
  try {
    const result = event.promise ? await event.promise : null;
    const { cart, detail } = result || {};

    requestAnimationFrame(() => {
      hydrateCartUI();
      if (event.action === 'add') resetDrawerScroll();
      requestAnimationFrame(() => {
        hydrateCartImages();
        hydrateMissingCartImages();
      });
    });
    setTimeout(() => {
      hydrateCartImages();
      hydrateMissingCartImages();
    }, 80);

    if (detail?.didError) return;

    const itemCount = Number(cart?.totalQuantity ?? detail?.itemCount);
    if (Number.isFinite(itemCount)) {
      await customElements.whenDefined('cart-icon');
      document.querySelectorAll('cart-icon').forEach((icon) => {
        if (typeof icon.renderCartBubble !== 'function') return;
        if (Number(icon.currentCartCount) !== itemCount) icon.renderCartBubble(itemCount);
      });
    }
  } catch (error) {
    if (error?.name !== 'AbortError') console.warn('[SOLMIRE] Cart UI sync skipped:', error);
  }
}

function onDrawerOpen(event) {
  if (!(event.target instanceof Element) || event.target.id !== 'cart-drawer') return;
  requestAnimationFrame(() => {
    hydrateCartUI();
    neutralizePageSqueeze();
    syncDesktopOverlay();
  });
}

function onDrawerClose(event) {
  if (!(event.target instanceof Element) || event.target.id !== 'cart-drawer') return;
  clearDesktopOverlay();
}

if (!window.__solmireCartBridgeBound) {
  window.__solmireCartBridgeBound = true;
  window.addEventListener('submit', preventDuplicateSubmit, true);
  document.addEventListener(StandardEvents.cartLinesUpdate, trackProductRequest);
  document.addEventListener(StandardEvents.cartError, showProductError);
  document.addEventListener(StandardEvents.cartError, showCartError);
  document.addEventListener(StandardEvents.cartLinesUpdate, syncCartUI);
  document.addEventListener('theme-drawer:open', onDrawerOpen);
  document.addEventListener('theme-drawer:close', onDrawerClose);
  document.addEventListener('shopify:section:load', hydrateCartUI);
  window.addEventListener('pageshow', hydrateCartUI);
  desktopDrawerQuery.addEventListener('change', syncDesktopOverlay);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrateCartUI, { once: true });
  } else {
    hydrateCartUI();
  }
}
